import SectionTitle from "./SectionTitle";

const TOPICS = [
  {
    no: "01",
    title: "这条现场视频，为什么会被人截掉开头？",
    preview: "把开头一段去掉后，先后关系完全不同——评论区有人扒出了原片时间戳。",
    count: 214,
  },
  {
    no: "02",
    title: "同一个人，两张截图里为什么位置对不上？",
    preview: "多数人以为是画面反了，直到有人放大地砖纹路才看出来是两张不同时段。",
    count: 158,
  },
  {
    no: "03",
    title: "目击者说“先听到声音”，镜头里能印证吗？",
    preview: "声音与画面的先后，需要回到原始实拍逐帧对，而不是听转述带节奏。",
    count: 96,
  },
  {
    no: "04",
    title: "流出图的 EXIF 时间被改过，怎么识别？",
    preview: "外行看像素，内行看文件属性与前后景的光照一致性，已有讨论帖整理方法。",
    count: 71,
  },
];

export default function Community() {
  return (
    <section id="discuss" className="scroll-mt-20 border-y border-foreground-200/70 bg-background-100/60 py-16 md:py-24">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <SectionTitle
          index="05"
          kicker="正在热议"
          title={<>同一批画面，不同的人看出不同细节</>}
          lead="每条档案下面的讨论，多是围绕“画面里的某个细节到底怎么解读”。看多了别人的角度，再回看原片，往往会有新发现。"
        />

        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-10">
          <ul className="space-y-4 lg:col-span-8">
            {TOPICS.map((t) => (
              <li key={t.no}>
                <article className="group flex flex-col gap-3 rounded-lg border border-foreground-200/70 bg-background-50 p-5 transition-colors hover:border-primary-300 md:flex-row md:items-center md:justify-between md:p-6">
                  <div className="flex gap-4">
                    <span className="font-serif text-lg font-black text-foreground-300 group-hover:text-primary-500">{t.no}</span>
                    <div>
                      <h3 className="font-serif text-[16px] font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-[18px]">
                        {t.title}
                      </h3>
                      <p className="mt-2 hidden text-sm leading-6 text-foreground-500 sm:block">{t.preview}</p>
                    </div>
                  </div>
                  <div className="flex shrink-0 items-center gap-4 pl-9 text-[12px] text-foreground-400 md:flex-col md:items-end md:gap-1 md:pl-0">
                    <span className="inline-flex items-center gap-1.5">
                      <i className="ri-chat-3-line text-[14px]" aria-hidden="true" />{t.count}
                    </span>
                    <span className="inline-flex items-center gap-1 text-primary-600 opacity-0 transition-opacity group-hover:opacity-100">
                      参与 <i className="ri-arrow-right-line text-[13px]" aria-hidden="true" />
                    </span>
                  </div>
                </article>
              </li>
            ))}
          </ul>

          <aside className="lg:col-span-4">
            <div className="sticky top-24 rounded-lg border border-foreground-200 bg-background-50 p-6">
              <span className="inline-flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-fire-line text-lg" aria-hidden="true" />
              </span>
              <h3 className="mt-4 font-serif text-xl font-bold text-foreground-950">想加入这场对表？</h3>
              <p className="mt-2 text-sm leading-6 text-foreground-500">
                把你在原片里看到的细节、或能对上的截图发到档案下方，标注好时间点即可。先看画面，再谈观点。
              </p>
              <a
                href="#top"
                className="mt-5 inline-flex w-full items-center justify-center gap-2 rounded-md border border-foreground-950 px-4 py-3 text-sm font-medium text-foreground-950 transition-colors hover:bg-foreground-950 hover:text-background-50 whitespace-nowrap"
              >
                <i className="ri-edit-2-line text-[15px]" aria-hidden="true" />去档案下发言
              </a>
              <p className="mt-3 text-[12px] leading-5 text-foreground-400">
                投稿与讨论仅在本页示意，未接入真实登录与提交。
              </p>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}